import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";

import "./select.css";
import { logDOM } from "@testing-library/react";

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: "10px",
    borderColor: "#C1CFEF",
    width: "100%",
    //boxShadow: 'none',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#C1CFEF" : "white",
    color: "#102048",
    "&:hover": {
      backgroundColor: "#C1CFEF",
    },
  }),
};

const ItemSelectBox = ({
  onInputChangeData,
  label,
  placeholder,
  className,
  name,
  options,
  value,
  onChange,
  error,
  setFormErrors = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const handleOptionClick = (option) => {
    setIsOpen(false);
  };

  const handleDelayedOptions = () => {
    setTimeout(() => {
      setIsOpen(true);
    }, 200);
  };

  useEffect(() => {
    console.log(options);
    if (options?.length > 10) {
      //handleDelayedOptions();
    }
  }, []);

//   useEffect(() => {
//   console.log("▶️ [ItemSelectBox Debug]");
//   console.log("Name:", name);
//   console.log("Current Value:", value);
//   console.log(
//     "Mapped Options:",
//     Array.isArray(options)
//       ? options.map((option) => {
//           if (option?.sale_invoice_id)
//             return {
//               value: option?.sale_invoice_id,
//               label: `${option?.sale_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})`,
//             };
//           if (option?.purchase_invoice_id)
//             return {
//               value: option?.purchase_invoice_id,
//               label: `${option?.purchase_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})`,
//             };
//           if (option?.exporter_invoice_id)
//             return {
//               value: option?.exporter_invoice_id,
//               label: `${option?.exporter_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})`,
//             };
//           if (option?.carrier_invoice_id)
//             return {
//               value: option?.carrier_invoice_id,
//               label: `${option?.carrier_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})`,
//             };
//           if (option?.wholesale_invoice_id)
//             return {
//               value: option?.wholesale_invoice_id,
//               label: `${option?.wholesale_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})`,
//             };
//           return {
//             value: option.id,
//             label:
//               option.type_name?.trim() ||
//               option.payment_category_name ||
//               option.name ||
//               "N/A",
//           };
//         })
//       : []
//   );
// }, [options, value, name]);

  const errorClass = error ? " border-1 border-red-500" : " border ";

  let selectedOption = { label: placeholder, value: value };


  // Map options the same way you map for <Select> options
  const mappedOptions = Array.isArray(options)
    ? options.map((option) => {
        if (option?.sale_invoice_id)
          return {
            value: option?.sale_invoice_id,
            label: `${option?.sale_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})`,
            original: option,
          };
        if (option?.purchase_invoice_id)
          return {
            value: option?.purchase_invoice_id,
            label: `${option?.purchase_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})`,
            original: option,
          };
        if (option?.exporter_invoice_id)
          return {
            value: option?.exporter_invoice_id,
            label: `${option?.exporter_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})`,
            original: option,
          };
        if (option?.carrier_invoice_id)
          return {
            value: option?.carrier_invoice_id,
            label: `${option?.carrier_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})`,
            original: option,
          };
        if (option?.wholesale_invoice_id)
          return {
            value: option?.wholesale_invoice_id,
            label: `${option?.wholesale_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})`,
            original: option,
          };
        return {
          value: option.id,
          label:
            option.type_name?.trim() ??
            option.payment_category_name ??
            option.name ??
            "N/A",
        };
      })
    : [];

  selectedOption = mappedOptions.find((opt) => opt.value === value) || { label: placeholder, value: value };
  const placeholderOption = { id: value, name: placeholder };

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsOpen(false);
    }
    if (!isOpen) {
      setTimeout(() => {}, 500);
    }
  };

  console.log("selectedOption.. ", selectedOption);
  console.log("MappedOption.. ", mappedOptions)

  return (
    <div className={`${className} w-full relative`}>
      <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
        {label}
      </label>
      <Select
        name={name}
        onChange={(event) => {
          onChange(event);
          /* if (setFormErrors) {
            setFormErrors({ name: null });
          } */
        }}
        className={` select w-full text-[#102048] font-normal placeholder:text-[#91919F] bg-transparent outline-none px-[0px]  text-md focus:outline-none ${
          setFormErrors ? " border-1 border-red-500" : ""
        }`}

        // Backup code of options
        // options={[
        //   placeholder ? { value: placeholderOption.id, label: placeholderOption.name } : { value: "", label: "Select" },
        //   ...(Array.isArray(options)
        //     ? options?.map((option) => (
        //       option?.sale_invoice_id
        //         ? { value: option?.sale_invoice_id, label: `${option?.sale_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})` }
        //         : option?.purchase_invoice_id
        //         ? { value: option?.purchase_invoice_id, label: `${option?.purchase_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})` }
        //         : option?.exporter_invoice_id
        //         ? { value: option?.exporter_invoice_id, label: `${option?.exporter_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})` }
        //         :  option?.carrier_invoice_id
        //         ? { value: option?.carrier_invoice_id, label: `${option?.carrier_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})` }
        //         : option?.wholesale_invoice_id
        //         ? { value: option?.wholesale_invoice_id, label: `${option?.wholesale_invoice_id} (Total Due: ${option?.total_due?.toFixed(2)})` }
        //         : { value: option.id, label: option.type_name ? option.type_name : option.payment_category_name }
        //     ))
        //     : []),
        //   ...(isOpen && Array.isArray(options)
        //     ? options?.map((option) => (
        //       { value: option.id, label: option.type_name?option.type_name: option.payment_category_name }
        //       ))
        //     : []),
        // ]}

        options={mappedOptions}
        value={selectedOption}
        styles={customStyles}
        placeholder={placeholder}
        isSearchable
        // onMenuOpen={() => handleDelayedOptions()}
        onMenuClose={() => setIsOpen(false)}
        onInputChange={(input) => {
          if (onInputChangeData) {
            onInputChangeData(input);
          }
        }}
      />
      {setFormErrors && (
        <div className="text-red-500 text-sm mt-1">{error}</div>
      )}
    </div>
  );
};
ItemSelectBox.defaultProps = {
  className: "",
};
export default ItemSelectBox;
